<template>
	<section class='knd-video__container'>
		<div class='knd-video_inner' v-if='loaded'>
			<div class='video-wrapper'>
				<video playsinline muted ref="video" v-on:click="onClickVideo" 
				:poster="'https://pointer-dev.kro-ncrv.nl/' + data.image[0].url">
					<source 
					:src="'https://pointer-dev.kro-ncrv.nl/' + data.video[0].url"
					type="video/mp4" />
					Uw browser werkt niet met de video tag.
				</video>		
				

			<div class="knd-overlay" v-if="state === videoStates.PAUSE">
				<h2 class='knd-overlay__title'>{{data.video_titel}}</h2>
			</div>

				<div 
					class='video--icon video--icon-mute' 
					v-on:click="onMute" >
					<Mute />
				</div>

				<div class='video-loop knd-center'>
					<div 
						class='video--icon video--icon-loop' 
						v-on:click="onReplay" 
						v-if="state === videoStates.END">
							<Replay />
					</div>
					<div v-on:click="onClickVideo"
						class='video--icon video--icon-play' 
						v-if="state === videoStates.PAUSE">
							<Play />
					</div>
				</div>		
			</div>	

		</div>
	</section>
</template>

<script>
	import axios from 'axios';
	import './scss/index.scss';

	import Replay from '@/assets/icons/replay-.svg?inline';
	import Play from '@/assets/icons/play-.svg?inline';
	import Pause from '@/assets/icons/stop-.svg?inline';
	import Mute from '@/assets/icons/volume-.svg?inline';

	let videoStates = {
		PLAYING: 'PLAYING',
		PAUSE: 'PAUSE',
		END: 'END'
	}

	const vueObject = {
		props: ['id'],
		components: {Mute, Replay, Play, Pause},
		data: function() {
			return {
				videoStates, 
				videoProgress: 0,
				replay: false,
				state: videoStates.PAUSE,
				loaded: false,
				data: {}
			}
		},
		mounted: function() {

			this.loadData(this.id).then((data) => {
				this.loaded = true;
				this.data = data;

				this.$nextTick(() => {
					this.setupListeners();
				});
			})
		},
		methods: {
			setupListeners() {
				this.video = this.$refs.video;


				this.video.addEventListener('ended', (e) => {
					this.replay = true;
					this.state = this.videoStates.END;
				});
			},

			onReplay() {
				this.video.currentTime = 0;
				this.video.play();
				this.state = this.videoStates.PLAYING;
			},

			onClickVideo() {
				if (this.video.paused || this.video.ended) {
					this.video.play();
					this.state = this.videoStates.PLAYING;
				} else {
					this.video.pause();
					this.state = this.videoStates.PAUSE;
				}
			},

			onMute() {
				this.video.muted = !this.video.muted;
			},

			loadData (id) {
				return new Promise((resolve, reject) => { 
					axios
						.get(process.env.VUE_APP_API + id)
						.then(result => {
							resolve({id, ...result.data});
						})
						.catch(error => {
							reject();
							throw new Error(`API ${error}`);
						});
				})
			}			
		}
	}

	export default vueObject;
</script>